import { render, staticRenderFns } from "./ManufacturerExpensesDistributor.vue?vue&type=template&id=2ee063a2&"
import script from "./ManufacturerExpensesDistributor.vue?vue&type=script&lang=js&"
export * from "./ManufacturerExpensesDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports